import * as types from './mutation-types'

export default {
  setUserInfo (state, obj) {
    state.userInfo = obj
    localStorage.setItem('userInfo', JSON.stringify(obj))
  },
  clearUserInfo (state) {
    state.userInfo = {}
    localStorage.removeItem('userInfo')
  },
  [types.SET_USERINFO]: (state, value) => {
    state.userInfo = value
  },
  setToken (state, str) {
    state.token = str
    localStorage.setItem('token', str)
  },
  clearToken (state) {
    state.userInfo = {}
    localStorage.removeItem('userInfo')
  },
  setCollapse (state, collapse) {
    state.collapse = collapse
  }
}



//////////////////
// WEBPACK FOOTER
// ./store/mutations.js
// module id = null
// module chunks = 